import { useToast } from "@/hooks/use-toast";
import { updateClaimSchema } from "@/schemas/claims";

export function useSidebarValidation() {
    const { toast } = useToast();

    const validateAndSave = async (
        field: keyof typeof updateClaimSchema.shape,
        value: any,
        onUpdate: (field: string, value: any) => Promise<void>
    ) => {
        const fieldSchema = updateClaimSchema.shape[field];
        const result = fieldSchema.safeParse(value);

        if (!result.success) {
            const errorMsg = (result.error as any).errors?.[0]?.message || "Invalid input";
            toast({
                title: "Invalid Input",
                description: errorMsg,
                variant: "destructive"
            });
            throw new Error(errorMsg);
        }

        await onUpdate(field as string, result.data);
    };

    return { validateAndSave };
}
